import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[imagePlaceholder]",
})
export class ImagePlaceholderDirective {
  private hasFallbackApplied = false;
  @Input() imageFallBack = "assets/images/fallback-image.png";

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.checkAndReplaceSrc();
  }

  private checkAndReplaceSrc() {
    const imageElementRef = this.elementRef.nativeElement as HTMLImageElement;
    if (!imageElementRef.src || imageElementRef.src.endsWith("undefined")) {
      imageElementRef.src = this.imageFallBack;
    }
  }

  @HostListener("error") onImageLoadError() {
    const imageElementRef = <HTMLInputElement>this.elementRef.nativeElement;

    if (this.hasFallbackApplied || imageElementRef.src === this.imageFallBack) {
      return;
    }

    this.hasFallbackApplied = true;
    imageElementRef.title = "Image Not Found";
    imageElementRef.alt = "Image Not Found";
    imageElementRef.src = this.imageFallBack;
  }
}
